var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form",
    {
      staticClass: "d-inline-block mr-2",
      attrs: { inline: "" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.search($event)
        }
      }
    },
    [
      _c(
        "b-form-group",
        { attrs: { size: "sm" } },
        [
          _c(
            "fup-input",
            {
              style: { "max-width": _vm.minimize ? "10rem" : "none" },
              attrs: { size: "sm", placeholder: "Поиск", value: _vm.value },
              on: { input: _vm.input }
            },
            [
              _c(
                "template",
                { slot: "append" },
                [
                  _c(
                    "fup-button",
                    {
                      attrs: { size: "sm", variant: "warning", type: "submit" }
                    },
                    [_c("fup-icon", { attrs: { name: "search" } })],
                    1
                  )
                ],
                1
              )
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }